import first from "lodash/first";
import last from "lodash/last";
import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";
import { findFirstNonEmptyString } from "scmp-sdk";

import { useImageUtils } from "scmp-app/lib/hooks";
import type { postiesVideoCardVideo$key } from "scmp-app/queries/__generated__/postiesVideoCardVideo.graphql";

import PlayIcon from "./play-icon.svg";
import {
  Container,
  IconContainer,
  ImageContainer,
  Label,
  StyledBaseImage,
  StyledBaseLink,
  TextContainer,
  Title,
} from "./styles";

type Props = {
  reference: postiesVideoCardVideo$key;
};

export const PostiesVideoCard: FunctionComponent<Props> = ({ reference: reference_ }) => {
  const video = useFragment(
    graphql`
      fragment postiesVideoCardVideo on Video {
        sections {
          value {
            name
          }
        }
        urlAlias
        headline
        socialHeadline
        image(filter: { type: MAIN_IMAGE }) {
          url
          title
        }
      }
    `,
    reference_,
  );

  const image = video?.image;

  const { getResizedImageUrl } = useImageUtils();
  const imgSource = image?.url ? getResizedImageUrl(image?.url, 930) : "";
  const imgTitle = image?.title ?? "";
  const label = last(first(video?.sections)?.value)?.name;
  const headline = findFirstNonEmptyString(video?.socialHeadline, video?.headline);

  return (
    <Container>
      <StyledBaseLink pathname={video.urlAlias}>
        {image && (
          <ImageContainer>
            <StyledBaseImage
              $aspectRatio="295 / 184"
              alt={imgTitle}
              lazyload={false}
              src={imgSource}
            />
            <IconContainer>
              <PlayIcon />
            </IconContainer>
          </ImageContainer>
        )}
        <TextContainer>
          <Label>{label}</Label>
          <Title>{headline}</Title>
        </TextContainer>
      </StyledBaseLink>
    </Container>
  );
};

PostiesVideoCard.displayName = "PostiesVideoCard";
